import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareNextgenRedirectRoute: InvariantJiraRoute = {
	name: 'software-nextgen-redirect',
	path: '/secure/NextGen.jspa',
};
